import { Inject } from '@angular/core';
import { CourseTableLabels } from '../models/types';
import { PriceListCourse } from '../models/pricelist-course.model';
import { BasePriceListBandsService } from './base-pricelist-bands.service';

@Inject({
  providedIn: 'root',
})
export class PriceListCourseBandsService extends BasePriceListBandsService<PriceListCourse> {
  /**
   * Returns the column labels for the course table.
   * Example:
   * [
   *   { band: '1-1', header: '1 week', subHeader: 'Total price' },
   *   { band: '2-3', header: '2-3 weeks', subHeader: 'Per week' },
   *   { band: '8-99', header: '8+ weeks', subHeader: 'Per week' },
   * ]
   */
  getColumnLabels(courses: PriceListCourse[]): CourseTableLabels {
    const bands = this.getSortedBands(courses);
    const headerColumns = this.getHeaderColumnsWithBands(
      bands,
      {
        singular: 'week',
        plural: 'weeks',
      },
      {
        perUnitLabel: 'Per week',
        totalPriceLabel: 'Total price',
      },
    );

    return {
      title: 'Courses',
      weeks: headerColumns,
    };
  }
}
